import React, { PureComponent } from 'react';
import { Popover as AntPopover, Button } from 'antd';
import { services } from '@comall-backend-builder/core';
import { ApiRequestConfig, api } from '@comall-backend-builder/core/lib/services/api';
import { errorHandle } from '../../services';

/**
 * 商品资料预览商品
 */
export class QrSmartCodeBtn extends PureComponent<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            goodContent: '',
        };
    }

    renderQrcode = async () => {
        const { type, id } = this.props.row;
        const params = {
            page: 'pages/preindex/index',
            scene: `t=p&p=${id}&checkStock=true`,
            width: 430,
        };
        const res: any = await services.api.post(params, {
            apiPath: '/orderReplaceSkn/get_mini_program',
        });
        this.setState({
            goodContent: `data:image/png;base64,${res.miniProgramCode}`,
        });
    };

    render() {
        const { goodContent } = this.state;
        const content = <img src={goodContent} alt="" />;
        return (
            <AntPopover title="智能推荐二维码" content={content} trigger="click">
                <a target="_blank" style={{ marginRight: 10 }} onClick={this.renderQrcode}>
                    智能推荐二维码
                </a>
            </AntPopover>
        );
    }
}
